import { APC_LOGO_BASE_64_SRC, APC_NAME } from './constants';
export const getAPCDistributor = (apcURL, stockLabel, imgPath) => {
  return {
    id: APC_NAME,
    name: APC_NAME,
    logoUrl: imgPath || APC_LOGO_BASE_64_SRC,
    isAvailable: true,
    buyUrl: apcURL,
    stockLabel,
    isFavorite: null,
    retailerSite: apcURL,
  };
};
export const getSingleDistributor = (distributorsList, productId) => {
  if (distributorsList
    && productId in distributorsList
    && Object.keys(distributorsList[productId]).length === 1) {
    return distributorsList[productId][0];
  }
  return null;
};
